<template>
  <fragment>
    <v-autocomplete
      :label="label"
      v-bind="[defaultProps, $attrs]"
      v-on="$listeners"
      :attach="attach"
      small-chips
    >
      <template #label>
        <slot name="label"
          >{{ label }}<span v-show="required" class="red--text"> *</span></slot
        >
      </template>
      <template #append>
        <slot name="append"> </slot>
      </template>
      <template #selection="{ item, index }" v-if="needSelection">
        <slot name="selection" :item="item" :index="index">
          {{ item }}
        </slot>
      </template>
      <template #item="{ item, index }" v-if="needSelection">
        <slot name="item" :item="item" :index="index">
          {{ item }}
        </slot>
      </template>
    </v-autocomplete>
  </fragment>
</template>

<script>
import { defaultPropsInput } from "@/mixins/defaultPropsInput";

export default {
  name: "BaseAutocomplete",
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: "",
    },
    labelClass: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
    },
    needSelection: {
      type: Boolean,
      default: false,
    },
    attach: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [defaultPropsInput],
};
</script>

<style lang="scss">
.base-text-field input {
  color: var(--v-grey-base) !important;
  margin-top: 0 !important;
}
.v-select__slot {
  padding-top: 2px;
}
</style>
